export default {
  EnbMsg: state => state.EnbMsg,
  Profile: state => state.Profile,
  Users: state => state.Users,
  SelectedUserEdit: state => state.SelectedUserEdit,
  Theme: state => state.Theme,
  Themes: state => state.Themes,
  SearchLoad: state => state.SearchLoad,
  Logo: state => state.Logo,
  Fonts: state => state.Fonts,
  Prefes: state => state.Prefes,
  Permission: state => state.Permission,
  Empresa: state => state.Empresa,
  GlobalLoading: state => state.Loading,
  UserValidate: state => state.UserValidate,
  PWrecovery: state => state.PWrecovery
}
